import {
    FETCH_RESET_OPERATIONS_REQUEST,
    FETCH_RESET_OPERATIONS_SUCCESS,
    FETCH_RESET_OPERATIONS_FAILURE,
} from '../../../Constants/actionTypes';

import { API_RESET_PAGE_CONTENT } from '../../../Constants/apiUrls';
import { fetchResetPageContent } from '../../../Constants/apiService'



// Action Creators
export const fetchResetOperationsRequest = () => ({
    type: FETCH_RESET_OPERATIONS_REQUEST,
});

export const fetchResetOperationsSuccess = (data) => ({
    type: FETCH_RESET_OPERATIONS_SUCCESS,
    payload: data,
});

export const fetchResetOperationsFailure = (error) => ({
    type: FETCH_RESET_OPERATIONS_FAILURE,
    payload: error,
});

// Thunk to fetch data with authorization
export const fetchResetOperations = () => async (dispatch, getState) => {
    dispatch(fetchResetOperationsRequest());
    try {
        // Retrieve access token from the state
        const state = getState();
        const accessToken = state.auth.accessToken;
        const data = await fetchResetPageContent(accessToken);
        dispatch(fetchResetOperationsSuccess(data));
    } catch (error) {
        let errorMessage;
        if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
            errorMessage = 'Server is currently down. Please try again later.';
        } else {
            errorMessage = error.message;
        }
        dispatch(fetchResetOperationsFailure(errorMessage));
    }
};

